import { RestRequest, RestContext, ResponseFunction } from 'msw'
import {
  addToEntityListData,
  updateEntityListData,
  deleteEntityListData,
} from '../../modules/mockDataCommon'
import { requireAuthenticatedUser } from '../../decorators'
import {
  getTeamMemberLastSelectedStateListData,
  getTeamMemberLastSelectedStateData,
} from './mockData'
import type { ITeamMemberLastSelectedState } from '~/types/teamMember/models'

interface GetTeamMemberLastSelectedStateListDataResponse {
  data: ITeamMemberLastSelectedState[]
}

async function getTeamMemberLastSelectedListData(
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) {
  const responseBody: GetTeamMemberLastSelectedStateListDataResponse = {
    data: await getTeamMemberLastSelectedStateListData(),
  }
  return res(ctx.status(200), ctx.json(responseBody))
}

interface GetTeamMemberLastSelectedStateResponse {
  data: ITeamMemberLastSelectedState
}

async function getTeamMemberLastSelectedState(
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) {
  const { id } = req.params
  if (typeof id !== 'string') {
    const responseBody = {
      statusCode: 500,
      message: 'Passed ID is not a string.',
    }
    return res(ctx.status(500), ctx.json(responseBody))
  }
  const responseBody: GetTeamMemberLastSelectedStateResponse = {
    data: await getTeamMemberLastSelectedStateData(id),
  }
  return res(ctx.status(200), ctx.json(responseBody))
}

// post

const postTeamMemberLastSelectedState = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return addToEntityListData(
    req,
    res,
    ctx,
    getTeamMemberLastSelectedStateListData
  )
}

const patchTeamMemberLastSelectedState = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return updateEntityListData(
    req,
    res,
    ctx,
    getTeamMemberLastSelectedStateListData
  )
}

const deleteTeamMemberLastSelectedState = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return deleteEntityListData(
    req,
    res,
    ctx,
    getTeamMemberLastSelectedStateListData
  )
}

export const handlers = [
  {
    method: 'get',
    path: '/api/teammemberlastselectedstates',
    handler: getTeamMemberLastSelectedListData,
  },
  {
    method: 'get',
    path: '/api/teammemberlastselectedstates/:id',
    handler: getTeamMemberLastSelectedState,
  },
  {
    method: 'post',
    path: '/api/teammemberlastselectedstates',
    handler: postTeamMemberLastSelectedState,
  },
  {
    method: 'patch',
    path: '/api/teammemberlastselectedstates/:id',
    handler: patchTeamMemberLastSelectedState,
  },
  {
    method: 'delete',
    path: '/api/teammemberlastselectedstates/:id',
    handler: deleteTeamMemberLastSelectedState,
  },
].map((h) => ({ ...h, ...{ handler: requireAuthenticatedUser(h.handler) } }))
